import React from 'react'
import { auth } from '../services/auth';
import { useState } from 'react';
import ItemPreview from './OrderItem';
import Loader from '../shared/Loader';
import { subCategoryService } from '../services/ProductService';
import FeatureService from '../shared/FeatureService';
import { addOrder, getById, deleteAllCartItems } from '../services/checkoutDetails';
import styles from "../css/checkoutDetails.module.css"

export default function CheckoutDetails({ products, params }) {

    const [description, setOrderDescription] = useState();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [firstName, setFirstName] = useState();
    const [lastName, setLastName] = useState();
    const [paymentComment, setPaymentComment] = useState();
    const user = auth().getUser();
    const token = auth().getToken();
    const [errors, setErrors] = useState({
        firstName: true,
        lastName: true,
        description: true,
        paymentComment: true
    });
    const [hasError, setHasError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [userData, setUserData] = useState();
    const [localProds, setlocalProds] = useState(products)

    const config = {
        headers: { Authorization: `Bearer ${token}` }
    };

    React.useEffect(() => {

        if (user !== null && user !== undefined) {
            getById(user, config)
                .then((response) => {
                    setUserData(response.data);
                    setFirstName(user.firstName);
                    setLastName(user.lastName);
                });
        }
    }, []);

    const clearData = () => {
        setOrderDescription("")
        setPaymentComment("")
    }

    const validateFields = (firstName, lastName, description, paymentComment) => {
        // true means invalid, so our conditions got reversed
        setErrors({
            firstName: firstName?.length > 0,
            lastName: lastName?.length > 0,
            description: description?.length > 0,
            // paymentComment: paymentComment?.length > 0
        })
    }
    const emptyCart = async () => {
        await deleteAllCartItems(user, config)
            .then((response) => {
                if (response.status === 200) {
                    setHasError(false);
                    clearData();
                }
            })
    }

    const placeOrder = async () => {
        setIsLoading(true);

        if (!firstName?.length > 0 || !lastName?.length > 0 || !description?.length > 0) {
            validateFields(firstName, lastName, description, paymentComment)
            setIsLoading(false);
            setError("Please fill all fields");
            return null;
        }

        let email = "";
        if (user !== null && user !== undefined) {
            email = userData.email;
        } else {
            email = localStorage.getItem("email")
        }
        const orderObject = {
            items: products,
            description,
            amount: 0,
            tax: 0,
            discount: 0,
            payment: { paymentComment: paymentComment },
            firstName: firstName,
            lastName: lastName,
            email: email
        }

        await addOrder(user, params, orderObject, config)
            .then((response) => {
                if (response.status === 200) {
                    if (params?.checkoutType === "1") {
                        clearData();
                        setHasError(false);
                        emptyCart()
                        setSuccess(true);
                        setTimeout(function () {
                            window.location.replace(response.data[0].paymentUrl);
                        }, 2000);
                    }
                    if (params?.checkoutType === "2") {
                        setHasError(false);
                        clearData();
                        emptyCart();
                        setSuccess(true);
                        setTimeout(function () {
                            window.location.replace("/orders")
                        }, 3000);
                    }
                }
                if (response.status === 400) {
                    setHasError(true);
                    setError("Invalid adding order, please try again");
                }
                return response.data;
            }).catch((error) => {
                setHasError(true);
                setError("Invalid adding order, please try again");
            })
            .finally(() => {
                clearData();
                setIsLoading(false);
            });
    }

    const removeItem = (value) => {
        setlocalProds((prod) => {
            return prod.filter((item, index) => index !== value);
        });
    }
    return (
        <div className='flex flex-col lg:flex-row justify-center gap-5'>
            {params.checkoutType === "1" ? (
                <div className='flex flex-col border border-gray-350 rounded-3xl flex-wrap basis-7/12'>
                    <div className='flex flex-col justify-center content-center self-center'>
                        <div className="">
                            <p className="my-10 text-lg text-pink-350 font-semibold">User details</p>
                        </div>
                        <div className="my-5 flex flex-col  ">
                            <label className="uppercase font-semibold" htmlFor="firstName">First Name</label>
                            <input className={`${styles.checkoutInput} ${!errors?.firstName ? " border-3 border-rose-600" : "border-b-gray-600"}`} type="input"
                                value={firstName}
                                onChange={e => setFirstName(e.target.value)}
                                name="firstName" id="firstName" required />
                            {!errors?.firstName ? (
                                <p className="text-red-600">This field is required!</p>
                            ) : null}
                        </div>
                        <div className="my-5 flex flex-col">
                            <label className="uppercase font-semibold" htmlFor="lastName">Last Name</label>
                            <input className={`${styles.checkoutInput} ${!errors?.lastName ? " border-3 border-rose-600" : "border-b-gray-600"}`} type="input"
                                value={lastName}
                                onChange={e => setLastName(e.target.value)}
                                name="lastName" id="lastName" required />
                            {!errors?.lastName ? (
                                <p className="text-red-600">This field is required!</p>
                            ) : null}
                        </div>
                        <div className="my-5 flex flex-col">
                            <label className="uppercase font-semibold" htmlFor="description">Description</label>
                            <input className={`${styles.checkoutInput} ${!errors?.description ? " border-3 border-rose-600" : "border-b-gray-600"}`} type="input"
                                value={description}
                                onChange={e => setOrderDescription(e.target.value)}
                                name="description" id="description" required />
                            {!errors?.description ? (
                                <p className="text-red-600">This field is required!</p>
                            ) : null}
                        </div>
                        {/* <div className="my-5 flex flex-col ">
                            <label className="uppercase font-semibold" htmlFor="paymentComment">Payment Comment</label>
                            <input className={`${styles.checkoutInput} ${!errors?.paymentComment ? " border-3 border-rose-600" : "border-b-gray-600"}`} type="input"
                                value={paymentComment}
                                onChange={e => setPaymentComment(e.target.value)}
                                name="paymentComment" id="paymentComment" required />
                            {!errors?.paymentComment ? (
                                <p className="text-red-600">This field is required!</p>
                            ) : null}
                        </div> */}
                        <div className="my-5 flex flex-col  ">
                            <label className="uppercase font-semibold  text-center" htmlFor="amount">Total Amount</label>
                            <input className={`transition ease-in-out  h-8 w-64 bg-white outline-0 font-semibold text-center self-center px-10 py-3 rounded-3xl  border-2 border-purple-300 bg-round-xl`} type="text"
                                value={`$${localProds.length > 0 && localProds?.map(prod => !prod.item[0]?.discount ? prod.item[0]?.price : prod.item[0]?.discountPrice).reduce((a, b) => a + b).toFixed(2)}`}
                                name="amount" id="amount" required disabled />
                        </div>
                    </div >
                </div>) : null}
            {params.checkoutType === "2" ? (
                <div className='flex flex-col border border-gray-350 justify-start rounded-3xl flex-wrap basis-7/12 gap-5 lg:gap-10'>
                    <div className='flex flex-row w-64  text-center px-10 py-3 mt-10 rounded-3xl self-center border-2 border-purple-300 bg-round-xl'>Deposit:<span className='font-semibold'>${userData?.deposit} </span> </div>
                    <div className="my-5 flex flex-col self-center">
                        <label className="uppercase font-semibold" htmlFor="description">Description</label>
                        <input className={`${styles.checkoutInput} ${!errors?.description ? " border-3 border-rose-600" : "border-b-gray-600"}`} type="input"
                            value={description}
                            onChange={e => setOrderDescription(e.target.value)}
                            name="description" id="description" required />
                        {!errors?.description ? (
                            <p className="text-red-600">This field is required!</p>
                        ) : null}
                    </div>
                    {/* <div className="my-5 flex flex-col ">
                        <label className="uppercase font-semibold" htmlFor="paymentComment">Payment Comment</label>
                        <input className={`${styles.checkoutInput} ${!errors?.paymentComment ? " border-3 border-rose-600" : "border-b-gray-600"}`} type="input"
                            value={paymentComment}
                            onChange={e => setPaymentComment(e.target.value)}
                            name="paymentComment" id="paymentComment" required />
                        {!errors?.paymentComment ? (
                            <p className="text-red-600">This field is required!</p>
                        ) : null}
                    </div> */}
                </div>
            ) : null}
            <div className="basis-5/12 p-5 border justify-center border-gray-350 rounded-3xl">
                <ItemPreview showMainContent={true}
                    socialLogo={subCategoryService(products[0]?.imgOriginalLink != undefined ? JSON.parse(products[0]?.imgOriginalLink)[0] : null)} //used when retrieving from Post not from cart
                    postData={products[0]?.postData}
                    products={products}
                    username={products[0]?.linkToPage}
                />
                {/* <div className='my-10 flex flex-row justify-center content-center'>
                    <button className="mt-3 mb-5 px-10 py-1 uppercase rounded-3xl justify-center border-2 border-pink-350 hover:text-pink-350 transition-all" type="button" value="Add a Coupon Code" >Add a Coupon Code</button>
                </div> */}
                <div className='flex flex-row justify-center content-center'>
                    <button onClick={placeOrder} className='my-5 px-20 py-3 w-80 self-start uppercase rounded-3xl text-white bg-pink-350 shadow-xl hover:opacity-90 transition-all'>Place order</button>
                </div>
                <FeatureService />
                <div className={`flex flex-row ${isLoading ? 'justify-center' : hasError ? 'justify-between' : 'justify-center'}`}>
                    {isLoading ?
                        (<div className="my-5 mx-20"> <Loader styles={"w-12 h-12"}></Loader> </div>) :
                        hasError ? ((<p className="my-10 text-l text-red-600">Failed placing order, please try again!</p>)) : null}
                </div>
                {success ? (
                    <div className="flex p-4 mb-4 text-sm text-white rounded-lg bg-green-50 dark:bg-gray-800 dark:text-green-400" role="alert">
                        <svg aria-hidden="true" className="flex-shrink-0 inline w-5 h-5 mr-3" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg"><path fillRule="evenodd" d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-7-4a1 1 0 11-2 0 1 1 0 012 0zM9 9a1 1 0 000 2v3a1 1 0 001 1h1a1 1 0 100-2v-3a1 1 0 00-1-1H9z" clipRule="evenodd"></path></svg>
                        <div>
                            <span className="font-medium">Success!</span> Sucessfully added order!
                        </div>
                    </div>
                ) : null}
            </div>
        </div>
    )
}